import {
  Box,
  Grid,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Tooltip,
  Button,
  OutlinedInput
} from '@mui/material';
import { Search as SearchIcon } from 'react-feather';
import React, { useState, useEffect } from 'react';
import DateRange from 'src/components/common/DateRange';
import RefreshIcon from '@mui/icons-material/Refresh';

const ReimbursementToolbar = (props) => {
  //const [claimStatus, setClaimStatus] = useState(["pre approved", "pre rejected", "partially pre approved"]);
  const [claimIdSearched, setClaimIdSearched] = useState();
  const [employeeIdSearched, setEmployeeIdSearched] = useState();
  const [viewportWidth, setViewportWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );
  const claimRemarks =
    props.activeTab == 0
      ? ['pre approved', 'pre rejected', 'partially pre approved', 'raised for payment',"information required",
      "submitted", "resubmitted"]
      : ['approved', 'rejected', 'partially approved', 'recheck'];

  const corporates = _.invert(props.entityListData);

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const filterClaims = () => {
    let claimStatuses = [];
    if (props.claimStatusSelections) {
      claimStatuses = Object.keys(props.claimStatusSelections).filter((ele) => {
        if (props.claimStatusSelections[ele] == true) {
          return true;
        } else {
          return false;
        }
      });
    }
    let payLoad = {};
    if (props.activeTab == 0) {
      payLoad['activeTab'] = 0;
    } else if (props.activeTab == 1) {
      payLoad['activeTab'] = 1;
    }else if (props.activeTab == 2) {
      payLoad['activeTab'] = 2;
    }
    payLoad['claimStatus'] = claimStatuses ? claimStatuses : null;
    payLoad['startDate'] = props.dateSelections[0]
      ? props.dateSelections[0]
      : null;
    payLoad['endDate'] = props.dateSelections[1]
      ? props.dateSelections[1]
      : null;
    payLoad['corporate'] = props.corporateSelections
      ? props.corporateSelections
      : null;
    props.onFilter(payLoad);
  };

  const claimsUnderQuery = () => {
    let claimStatuses = [];
    let payLoad = {};
    
    payLoad['startDate'] = props.dateSelections[0]
      ? props.dateSelections[0]
      : null;
    payLoad['endDate'] = props.dateSelections[1]
      ? props.dateSelections[1]
      : null;
    payLoad['corporate'] = props.corporateSelections
      ? props.corporateSelections
      : null;
    props.onFilter(payLoad);
  };

  const searchClaim = () => {
    let claimStatuses = [];
    if (props.claimStatusSelections) {
      claimStatuses = Object.keys(props.claimStatusSelections).filter((ele) => {
        if (props.claimStatusSelections[ele] == true) {
          return true;
        } else {
          return false;
        }
      });
    }
    let payLoad = {};
    if (props.activeTab == 0) {
      payLoad['activeTab'] = 0;
    } else if (props.activeTab == 1) {
      payLoad['activeTab'] = 1;
    }
    payLoad['corporate'] = props.corporateSelections
      ? props.corporateSelections
      : null;
    payLoad['claimid'] = claimIdSearched;
    props.onSearch(payLoad);
  };

  const searchEmployeeClaims = () => {
    let claimStatuses = [];
    if (props.claimStatusSelections) {
      claimStatuses = Object.keys(props.claimStatusSelections).filter((ele) => {
        return props.claimStatusSelections[ele]
      });
    }
    let payLoad = {};

    payLoad['activeTab'] = props.activeTab

    payLoad['corporate'] = props.corporateSelections
      ? props.corporateSelections
      : null;
    payLoad['employeeid'] = employeeIdSearched;
    props.onSearch(payLoad);
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  }

  const selectedClaimStatuses = Object.keys(props.claimStatusSelections).filter(
    (ele) => props.claimStatusSelections[ele]
  );

  const selectedCorporateName = props.corporateSelections
    ? props.entityListData[props.corporateSelections]
    : '';

  const clampNumber = (value, min, max) => Math.min(max, Math.max(min, value));
  const lerp = (a, b, t) => a + (b - a) * t;
  const widthT = clampNumber((viewportWidth - 320) / (1200 - 320), 0, 1);
  const claimStatusMaxChars = Math.round(lerp(14, 28, widthT));
  const corporateMaxChars = Math.round(lerp(16, 40, widthT));

  return (
    <Box>
      <Grid container spacing={2} alignItems="center">

      <Grid item xs={12} sm={4} sx={{mr:5}}>
        <FormControl size="small" fullWidth variant="outlined">
          <InputLabel
            id="claim-status-label"
            shrink={selectedClaimStatuses.length > 0}
            sx={{
              opacity: selectedClaimStatuses.length > 0 ? 1 : 0,
              transition: (theme) =>
                theme.transitions.create(['opacity', 'transform'], {
                  duration: theme.transitions.duration.shorter
                })
            }}
          >
            Claim Status
          </InputLabel>
          <Select
            multiple
            displayEmpty
            labelId="claim-status-label"
            id="claim-status"
            label={selectedClaimStatuses.length > 0 ? 'Claim Status' : ''}
            value={selectedClaimStatuses}
            onChange={(e) => props.updateToolbarClaimStatues(e.target.value, null)}
            renderValue={(selected) => {
              if (!selected || selected.length === 0) {
                return (
                  <Box
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: 'text.secondary'
                    }}
                  >
                    Claim Status
                  </Box>
                );
              }

              const full = selected.join(', ');
              const first = selected[0] || '';
              const firstTruncated =
                first.length > claimStatusMaxChars
                  ? `${first.slice(0, claimStatusMaxChars)}...`
                  : first;
              const label = selected.length === 1 ? firstTruncated : `${firstTruncated}...`;

              return (
                <Box
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                  title={full}
                >
                  {label}
                </Box>
              );
            }}
            sx={{
              bgcolor: '#fff',
              borderRadius: 2,
              minWidth: 'clamp(180px, 28vw, 220px)',
              '& .MuiSelect-select': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }}
          >
            {claimRemarks.map((val, idx) => (
              <MenuItem key={idx} value={val}>
                <Checkbox checked={props.claimStatusSelections[val]} size="small" />
                <ListItemText primary={val} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={3} sx={{mr:5}}>
        <FormControl size="small" fullWidth variant="outlined">
          <InputLabel
            id="corporate-label"
            shrink={Boolean(props.corporateSelections)}
            sx={{
              opacity: props.corporateSelections ? 1 : 0,
              transition: (theme) =>
                theme.transitions.create(['opacity', 'transform'], {
                  duration: theme.transitions.duration.shorter
                })
            }}
          >
            Corporate
          </InputLabel>
          <Select
            value={props.corporateSelections}
            onChange={(ev) => props.updateCorporateSelections(ev.target.value)}
            displayEmpty
            labelId="corporate-label"
            id="corporate"
            label={props.corporateSelections ? 'Corporate' : ''}
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <Box
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: 'text.secondary'
                    }}
                  >
                    Corporate
                  </Box>
                );
              }

              const corporateLabel =
                selectedCorporateName.length > corporateMaxChars
                  ? `${selectedCorporateName.slice(0, corporateMaxChars)}...`
                  : selectedCorporateName;

              return (
                <Box
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                  title={selectedCorporateName}
                >
                  {corporateLabel}
                </Box>
              );
            }}
            sx={{
              bgcolor: '#fff',
              borderRadius: 2,
              minWidth: 'clamp(170px, 26vw, 200px)',
              '& .MuiSelect-select': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }}
          >
            {Object.keys(corporates).map((val, idx) => (
              <MenuItem key={idx} value={corporates[val]}>
                <Checkbox checked={corporates[val] === props.corporateSelections} />
                <ListItemText primary={val} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={8} sm={3} sx={{mr:5}}>
        <DateRange
          onDateChange={(value) => {
            const startDate = convert(value[0]);
            const endDate = convert(value[1]);
            props.updateDateSelections(startDate, endDate);
          }}
        />
      </Grid>

      <Grid item xs={4} sm={2}>
        <Button
          fullWidth
          variant="contained"
          sx={(theme) => ({
            height: 40,
            borderRadius: 999,
            fontWeight: 700,
            textTransform: 'none',
            letterSpacing: 0.2,
            boxShadow: '0 10px 22px rgba(23,120,242,0.20)',
            '&:hover': {
              boxShadow: '0 14px 28px rgba(23,120,242,0.26)',
              backgroundColor: theme.palette.primary.dark
            },
            '&:active': {
              transform: 'translateY(1px)'
            },
            '& .MuiButton-startIcon': {
              marginRight: theme.spacing(0.75)
            }
          })}
          onClick={filterClaims}
          startIcon={<RefreshIcon />}
        >
          Submit
        </Button>
      </Grid>
      </Grid>



    <Grid container spacing={2} alignItems="center" sx={{ mt: 4 }}>

      <Grid item xs={12} sm={6} sx={{mr:15}}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'nowrap', width: '100%' }}>
          <OutlinedInput
            fullWidth
            size="small"
            sx={{
              bgcolor: '#f6f7f9',
              borderRadius: '12px',
              flex: '1 1 auto',
              minWidth: 0
            }}
            onChange={(e) => setClaimIdSearched(e.target.value)}
            placeholder="Search for claimId"
          />
          <Button
            disabled={!claimIdSearched}
            variant="outlined"
            startIcon={<SearchIcon size={16} />}
            onClick={searchClaim}
            sx={{ whiteSpace: 'nowrap', flex: '0 0 auto' }}
          >
            Search
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'nowrap', width: '100%' }}>
          <OutlinedInput
            fullWidth
            size="small"
            sx={{
              bgcolor: '#f6f7f9',
              borderRadius: '12px',
              flex: '1 1 auto',
              minWidth: 0
            }}
            onChange={(e) => setEmployeeIdSearched(e.target.value)}
            placeholder="Enter Employee ID"
          />
          <Button
            disabled={!employeeIdSearched}
            variant="outlined"
            startIcon={<SearchIcon size={16} />}
            onClick={searchEmployeeClaims}
            sx={{ whiteSpace: 'nowrap', flex: '0 0 auto' }}
          >
            Search
          </Button>
        </Box>
      </Grid>

    </Grid>
      {/* 
      <Grid
        item
        sx={{ width: '70px', marginTop: '-15px' }}
        container
        alignContent="center"
        justifyItems="center"
      >
        <Tooltip title="Reset">
          <IconButton
            sx={{
              bgcolor: 'white',
              boxShadow: '0 0 4px rgba(0,0,0,0.31)'
            }}
            color="primary"
            size="small"
            onClick={() => window.location.reload()}
          >
            <ClearIcon color="primary" />
          </IconButton>
        </Tooltip>
      </Grid> */}
    </Box>
  );
};

export default ReimbursementToolbar;
